import { setPage } from '@/store/slices/publicSlice';
import { useDispatch } from 'react-redux';

export const useSharedFunctions = () => {
  const dispatch = useDispatch();
  const resetPage = () => dispatch(setPage(0));

  return { resetPage };
};
